import { API_URL, jwtToken } from "../../../context/appContext";
export default async function updateUserSettings(data) {
    return fetch(`${API_URL}/api/settings_custom_prices`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + jwtToken
        }, body: JSON.stringify(data)
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => err)
}
